import { Capacitor } from '@capacitor/core'

// Export setup function for Vue 3
export const setupCapacitor = app => {
  app.config.globalProperties.$isNative = Capacitor.isNativePlatform()
  app.config.globalProperties.$platform = Capacitor.getPlatform()
}

// Export Capacitor platform info for direct imports
export const isNative = Capacitor.isNativePlatform()
export const platform = Capacitor.getPlatform()

export default true
